import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d7a092e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "length-participant-container",
  class: "section-max-w mlr-auto flex j-between"
}
const _hoisted_2 = { class: "logistics-info-container flex align-c" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logistics-icon",
  src: "/icons/clock-line-icon.svg",
  alt: "engine gears"
}, null, -1))
const _hoisted_4 = { class: "logistics-info flex align-s" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "static-large text-white" }, "Length of Session:", -1))
const _hoisted_6 = { class: "static-medium text-blue" }
const _hoisted_7 = {
  id: "participant-info-container",
  class: "logistics-info-container flex align-c"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logistics-icon",
  src: "/icons/meeting-icon.svg",
  alt: "engine gears"
}, null, -1))
const _hoisted_9 = { class: "flex column align-s" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "static-large text-white" }, "Participants:", -1))
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.serviceItem && _ctx.serviceItem.length && _ctx.serviceItem.participants)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.serviceItem.length), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceItem.participants.list, (p, pIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "participant-item text-blue",
                  key: pIndex
                }, [
                  _createTextVNode(_toDisplayString(p), 1),
                  (pIndex !== _ctx.serviceItem.participants.list.length - 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, ", "))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}